<template>
  <div>
    <v-menu
      v-model="menu1"
      :close-on-content-click="false"
      full-width
      max-width="290"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="computedDateFormattedMomentjs"
          :label="label"
          readonly
          v-on="on"
          hide-details
        ></v-text-field>
      </template>
      <v-date-picker v-model="date" @change="updateDate()"></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
  import moment from "moment";
  export default {
    props: ["sentDate", "label"],
    watch: {
      sentDate: function () {
        this.date = this.sentDate;
      },
    },
    data: () => ({
      date: null,
      menu1: false,
    }),
    mounted() {
      this.date = this.sentDate;
    },
    computed: {
      computedDateFormattedMomentjs() {
        return this.date ? moment(this.date).format("DD-MMM") : "";
      },
    },
    methods: {
      updateDate() {
        this.menu1 = false;
        if (this.sentDate != this.date) {
          this.$emit("dateChanged", `${this.date} 00:00:00`);
        }
      },
    },
  };
</script>